<div class="integration-bag">
  @for (integration of integrations; track integration) {
    <div class="integration"
      (click)="onClick(integration)"
      [ngClass]="integration.category === 'bot' && integration._inRoom ? 'added' : '' "
      >
      @if (integration.category !== 'bot') {
        <div >
          <img class="integration-avatar" [src]="getSafeUrl(integration.avatarUrl)"/>
          <div class="integration-name">{{integration.displayName | translate}}</div>
          <div class="integration-description">{{ integration.description | translate }}</div>
        </div>
      }
      @if (integration.category === 'bot') {
        <div >
          <img class="integration-avatar border-avatar" [src]="getSafeUrl(integration.avatarUrl)"/>
          <div
            class="integration-name-bot"
            [ngbTooltip]="integration.displayName | translate"
            >
            {{integration.displayName | translate}}
          </div>
          <div
            class="integration-description-bot"
            >
            {{ integration.description | translate }}
          </div>
        </div>
      }
      @if ((!integration.isOnline && integration.category !== 'bot')) {
        <div class="integration-offline error-text"
          >
          <i class="fa fa-exclamation-triangle"></i>
        </div>
      }
      @if (integration.category === 'bot') {
        <div class="bot-toggle">
          @if (isLoading) {
            <div class="container-spinner">
              <svg class="spinner-add" viewBox="25 25 50 50">
                <circle class="path-add" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"></circle>
              </svg>
            </div>
          }
          @if (!isLoading) {
            <div class="action-bot">
              @if (!integration._inRoom) {
                <div>
                  <i class="fa fa-plus"></i>
                </div>
              }
              @if (integration._inRoom) {
                <div>
                  <i class="fa fa-check"></i>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
